import React from 'react';
import useEnterKey from 'hooks/useKeydown';
import styled from 'styled-components';
import  Spinner  from 'ui-kit/Spinner';

import Modal from '../Modal';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onCancel,
  onSubmit,
  cancelText = 'No',
  submitText = 'Yes',
  title,
  description,
  isLoading = false
}) => {

  if (!isOpen) {
    return;
  }

  useEnterKey('Enter', onSubmit);

  return (
    <Modal isOpen={isOpen} canClose={true} onClose={onClose}>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Buttons>
        <CancelButton onClick={onCancel}>{cancelText}</CancelButton>
        <ApproveButton onClick={isLoading ? undefined : onSubmit}>
          {isLoading ? <Spinner size={20} color="white" /> : submitText}
        </ApproveButton>
      </Buttons>
    </Modal>
  );
};

export default ConfirmationModal;

const Title = styled.div`
  text-align: center;
  letter-spacing: 0.166667px;
  color: #ffffff;
  font-size: 24px;
  line-height: 40px;
  //margin-bottom: 29px;
  font-weight: bold;
  font-family: Nunito Sans !important;
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.171429px;
  color: #ffffff;
  margin-bottom: 13px;
  font-family: Nunito Sans !important;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const CancelButton = styled.div`
  font-family: Nunito Sans !important;
  font-weight: bold;
  width: 158px;
  margin: 7px;
  height: 44px;
  border: 1px solid rgba(255, 126, 85, 1);
  color: rgba(255, 126, 85, 1);
  box-sizing: border-box;
  border-radius: 100px;
  font-size: 18px;
  line-height: 15px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;

const ApproveButton = styled.div`
  font-family: Nunito Sans !important;
  margin: 7px;
  width: 158px;
  height: 44px;
  background: rgba(255, 126, 85, 1);
  padding-left: 36px;
  padding-right: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  cursor: pointer;
  border-radius: 1000px;
  font-size: 18px;
  line-height: 15px;
  text-align: center;
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);

  :hover {
    opacity: 0.8;
  }
`;
